import React from "react";

export const PlaylistGridSkeleton: React.FC = () => {
  return (
    <div className="geners-box-content md:mb-[64px] mb-[32px] grid 2xl:grid-cols-3 md:grid-cols-2 grid-cols gap-[24px] flex-wrap">
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          className="geners-list flex flex-1 bg-[#0E0E10] p-4 rounded-[20px] gap-5 animate-pulse"
        >
          <div className="geners-img">
            <div
              className="bg-[#1a1a1a] rounded-lg"
              style={{ width: "168px", height: "168px", aspectRatio: "1 / 1" }}
            />
          </div>
          <div className="geners-detail w-full">
            <div className="full-logo mb-4">
              <div className="bg-[#1a1a1a] rounded h-[29px] w-[102px]" />
            </div>
            <div className="bg-[#1a1a1a] rounded h-6 w-3/4 mb-2" />
            <div className="bg-[#1a1a1a] rounded h-5 w-1/2 mb-4" />
            <div className="geners-follow-deatils flex justify-between items-center sm:pr-6">
              <div className="bg-[#1a1a1a] rounded h-4 w-20" />
              <div className="bg-[#82879833] h-[40px] w-[2px]" />
              <div className="bg-[#1a1a1a] rounded h-4 w-24" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

